import {
    Component, ElementRef, OnInit, Input, Output, DoCheck, EventEmitter, OnChanges,
    SimpleChanges
} from '@angular/core';
import {StringUtils} from '../../shared/utils/src/string.utils';
import {ValidatorUtils} from '../../shared/utils/src/validator.utils';
import {AuthServices} from '../../shared/authentications/src/auth.services';
import * as _ from 'lodash';

@Component({
    selector: 'text-with-auto-resize-form',
    templateUrl: './text-with-auto-resize-form.component.html',
    styleUrls: ['./text-with-auto-resize-form.component.scss']
})

export class TextWithAutoResizeFormComponent implements OnChanges, DoCheck {
    private oldValue: string;
    private oldFormStatus: string;
    @Input() public ifError: string;
    @Input() public inputID: string;
    @Input() public type: string;
    @Input() public value: string;
    @Input() public viewType: string;
    @Input() public tcktNo: number;
    @Input() public titleClass: string;
    @Input() public isDuplicate: string;
    @Input() public rsrcPathVal = '';

    @Input() public set mode(mode: string){
        this.form.status = mode;
    }

    @Input() public set editable(editable: boolean){
        if (editable) {
            this.form.status = 'edit';
        } else {
            this.form.status = 'normal';
        }
    }

    @Output() public changedValue: EventEmitter<any> = new EventEmitter;

    public form: any = {
        status : 'normal' // edit || normal 모드 둘 중에 하나지 머.
    };

    public isHasLength = false;

    constructor(public authService: AuthServices) {
    }

    ngDoCheck() {
        if (this.value) {
            if (this.value.length) {
                this.isHasLength = true;
            }
        }

        if (this.isDuplicate !== undefined && this.isDuplicate !== '') {
            this.duplCheck(this.isDuplicate);
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        const chng = changes['value'];

        if (chng !== undefined) {
            if (chng.currentValue !== undefined && (chng.currentValue !== chng.previousValue)) {
                // 서버에서 html escape 처리되어 내려온 스트링을 unescape 처리하여 정상적으로 보이게 처리
                this.value = _.unescape(this.value);
            }
        }

        const chngTcktNo = changes['tcktNo'];
        const chngViewType = changes['viewType'];
        const chngValue = changes['value'];
        if (chngTcktNo || chngViewType || chngValue) {
            this.form.status = 'normal';
            this.isDuplicate = 'N';
        }

        if (this.isDuplicate === undefined) {
            this.oldValue = this.value;
        }
        $('#emptyInvalid').prop('hidden', true);
    }

    copyValueToSpanAndGetWidthSpan ($event?) {
        if ($event) {
            this.value = $event.target.value;
        }
    }

    // 버튼 클릭 : 상태 변경
    changeStatus(arg) {
        if (arg === 'edit') {
            this.form.status = 'edit';
        } else if (arg === 'submit') {
            if (this.inputValCheck(this.value)) {
                this.changedValue.emit(this.value);
                this.form.status = 'normal';
            }
        } else if (arg === 'cancel') {
            this.isDuplicate = undefined;
            this.value = this.oldValue;
            this.form.status = 'normal';
            $('#textInput').removeAttr('invalid');

            $('#duplicateInvalid').prop('hidden', true);
            $('#emptyInvalid').prop('hidden', true);
            $('#maxLengthInvalid').prop('hidden', true);
            $('#spcCharInvalid').prop('hidden', true);
        }
    }

    // 중복 체크 및 해제
    duplCheck(isDuplicate: string) {
        if (isDuplicate === 'Y') {
            this.value = this.oldValue;
            this.form.status = 'edit';
            $('#textInput').attr('invalid', true);

            $('#emptyInvalid').prop('hidden', true);
            $('#maxLengthInvalid').prop('hidden', true);
            $('#duplicateInvalid').prop('hidden', false);
            $('#spcCharInvalid').prop('hidden', true);
        } else if (isDuplicate === 'N') {
            this.oldValue = this.value;
            this.form.status = 'normal';
            $('#duplicateInvalid').prop('hidden', true);
        }
        this.isDuplicate = undefined;
    }

    // 빈 값 체크
    emptyCheck(val: string): boolean {
        if (StringUtils.isEmpty(val)) {
            this.form.status = 'edit';
            $('#textInput').attr('invalid', true);

            $('#emptyInvalid').prop('hidden', false);
            $('#maxLengthInvalid').prop('hidden', true);
            $('#duplicateInvalid').prop('hidden', true);
            $('#spcCharInvalid').prop('hidden', true);
            this.value = '';
            return false;
        } else {
            this.form.status = 'normal';
            $('#emptyInvalid').prop('hidden', true);
            return true;
        }
    }

    maxLengthCheck(val: string): boolean {
        if (StringUtils.checkMinStr(val, 2) || StringUtils.checkMaxStr(val, 200)) {
            this.form.status = 'edit';
            $('#textInput').attr('invalid', true);

            $('#emptyInvalid').prop('hidden', true);
            $('#maxLengthInvalid').prop('hidden', false);
            $('#duplicateInvalid').prop('hidden', true);
            $('#spcCharInvalid').prop('hidden', true);
            return false;
        } else {
            this.form.status = 'normal';
            $('#maxLengthInvalid').prop('hidden', true);
            return true;
        }
    }

    specialCharCheck(val: string): boolean {
        if (val.includes('"')) {
            this.form.status = 'edit';
            $('#textInput').attr('invalid', true);

            $('#emptyInvalid').prop('hidden', true);
            $('#maxLengthInvalid').prop('hidden', true);
            $('#duplicateInvalid').prop('hidden', true);
            $('#spcCharInvalid').prop('hidden', false);
            return false;
        } else {
            this.form.status = 'normal';
            $('#spcCharInvalid').prop('hidden', true);
            return true;
        }
    }

    inputValCheck(val: string): boolean {
        if (!this.emptyCheck(val)) {
            return false;
        } else if(!this.specialCharCheck(val)) {
            return false;
        } else {
            return this.maxLengthCheck(val);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/text-with-auto-resize-form/text-with-auto-resize-form.componenet.ts